import { useMutation } from "@tanstack/react-query";
import { AxiosError } from "axios";
import { updateHomeworkSharingSettings } from "../../../api/endpoints/HomeworkEndpoints";

export default function useUpdateHomeworkSharingSettings(homeworkId: string) {
  return useMutation<void, AxiosError, { enabled: boolean }>({
    mutationKey: ["update-homework-sharing-settings", homeworkId],
    mutationFn: ({ enabled }) =>
      updateHomeworkSharingSettings(homeworkId, enabled),
  });
}
